import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'themeHeadingText',
})
export class ThemeHeadingTextPipe implements PipeTransform {
  public transform(value: any, color: string) {
    if (value) {
      // Find all 'heading' tags
      const htmlString = value as string;
      let modifiedHtml = htmlString;

      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(headingTag => {
        // Regex to match opening heading tags (with or without existing attributes)
        const regex = new RegExp(`<${headingTag}([^>]*)>`, 'gi');
        
        modifiedHtml = modifiedHtml.replace(regex, (match, attributes) => {
          // Check if style attribute already exists
          if (attributes.includes('style=')) {
            // Add to existing style attribute
            return match.replace(/style\s*=\s*["']([^"']*)["']/i, `style="$1; color: somecolor;"`);
          } else {
            // Add new style attribute
            return `<${headingTag}${attributes} style="color: ${color};">`;
          }
        });
      });

      return modifiedHtml;
    }
    return value
  }
}